import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Button, Container, Reveal, SectionLabel } from './primitives';
import { RESULT_KPIS, BOOKING_URL } from './constants';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

export default function Results() {
  const { t } = useTranslation();
  const { events: gaEvents } = useGoogleAnalytics();

  const labels = t('home.results.items', { returnObjects: true });
  const labelList = Array.isArray(labels) ? labels : [];

  return (
    <section id="results" className="relative overflow-hidden bg-ink py-20 sm:py-28">
      <div className="pointer-events-none absolute -bottom-32 left-1/2 h-80 w-[40rem] -translate-x-1/2 rounded-full bg-accent opacity-15 blur-[120px]" />
      <Container className="relative">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionLabel tone="light">{t('home.results.eyebrow')}</SectionLabel>
          <h2 className="mt-5 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {t('home.results.title')}
          </h2>
          <p className="mt-4 text-lg text-white/55">{t('home.results.subtitle')}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3">
          {RESULT_KPIS.map((kpi, i) => (
            <Reveal
              key={i}
              delay={(i % 3) * 70}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-all duration-300 hover:-translate-y-1 hover:bg-white/[0.06]"
            >
              <div className="bg-accent-gradient bg-clip-text text-4xl font-extrabold text-transparent sm:text-5xl">
                {kpi.value}
              </div>
              <div className="mt-2 text-sm text-white/55">{labelList[i]}</div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 flex justify-center">
          <Button
            href={BOOKING_URL}
            external
            variant="primary"
            onClick={() => gaEvents.homeBookDemo('results')}
          >
            {t('home.results.cta')}
            <ArrowRight className="h-4 w-4" />
          </Button>
        </Reveal>
      </Container>
    </section>
  );
}
